import axios from "axios";

import { trackUserBlocked, trackUserUnblocked } from "../analytics/events";

/**
 * Bloqueio entre usuários.
 *
 * O efeito é bilateral: enquanto existir bloqueio em qualquer direção, a
 * conversa fica congelada para os dois e nenhum dos dois volta a aparecer nas
 * telas de descoberta do outro. A direção só importa para a UI — quem bloqueou
 * vê "Desbloquear", quem foi bloqueado vê o aviso e o botão de bloquear de
 * volta. Tudo é decidido no backend; aqui é só transporte.
 */

/** Bloqueia um usuário. Idempotente no backend. */
export async function blockUser(blockedUserId) {
  const response = await axios.post("/v1/blocks", { blockedUserId });
  trackUserBlocked(blockedUserId);
  return response;
}

/** Desfaz o bloqueio. Não restaura match nem solicitação. */
export async function unblockUser(blockedUserId) {
  const response = await axios.delete(
    `/v1/blocks/${encodeURIComponent(blockedUserId)}`,
  );
  trackUserUnblocked(blockedUserId);
  return response;
}

/** Lista os usuários bloqueados por mim (tela de gerenciamento). */
export function getBlockedUsers({ page = 1, limit = 50 } = {}) {
  return axios.get(`/v1/blocks?page=${page}&limit=${limit}`);
}

/**
 * Os dois conjuntos de ids de uma vez.
 *
 * A lista de conversas chega ao app direto do Firestore (onSnapshot), sem
 * passar pela API — então o filtro de bloqueio precisa acontecer no cliente,
 * e é esta chamada que o alimenta.
 */
export function getBlockIds() {
  return axios.get("/v1/blocks/ids");
}

/** Status do bloqueio com um usuário específico. */
export function getBlockStatus(userId) {
  return axios.get(`/v1/blocks/status/${encodeURIComponent(userId)}`);
}
